<template>
  <div class="zj-layout-main-content bgcolor scrollable" style="overflow: auto">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="16rem"
      style="width: 80%"
    >
      <zj-layout-container>
        <zj-layout-header>
          <div class="listtitle">摄像头设备详情</div>
        </zj-layout-header>
      </zj-layout-container>
        <el-row :gutter="14" v-if="form.protocol == 'gb28181'">
            <el-col :span="12">
              <el-form-item label="设备ID" prop="deviceId">
                <el-input v-model="form.deviceId" placeholder="系统同步,不支持修改" disabled/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="监控点code" prop="channelId">
                  <el-input v-model="form.channelId" disabled/>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="14">
          <el-col :span="12">
            <el-form-item label="设备名称" prop="name" :rules="[{ required: form.protocol == 'rtsp'? true : false, message: '设备名称不能为空', trigger: 'blur' }]">
              <el-input v-model="form.name" :disabled="form.protocol != 'rtsp' && IsEdit ? true : false" />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="设备接入方式" prop="protocol">
              <el-select
                v-model="form.protocol"
                clearable
                filterable
                placeholder="请选择"
                disabled
                style="width: 100%"
              >
                <el-option v-for="item in dict2.type['video-protocol']" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="14">
           <el-col :span="12">
             <el-form-item label="省" prop="provinceCode"  :rules="[{ required: true, message: '请选择省', trigger: 'blur' }]">
              <el-select v-model="form.provinceCode" clearable filterable placeholder="请选择" style="width: 100%" @change="getCity(form.provinceCode,'reset')" :disabled="form.protocol != 'rtsp' ? true : false">
                <el-option v-for="item in provinceList" :key="item.id" :label="item.name" :value="item.provinceCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="州/市" prop="cityCode"  :rules="[{ required: true, message: '请选择州/市', trigger: 'blur' }]">
              <el-select v-model="form.cityCode" clearable filterable placeholder="请选择" style="width: 100%" @change="getDistrict(form.cityCode,'reset')" :disabled="false">
                <el-option v-for="item in cityList" :key="item.id" :label="item.name" :value="item.cityCode" />
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="14">
          <el-col :span="12">
            <el-form-item label="区/县" prop="districtCode"  :rules="[{ required: true, message: '请选择区/县', trigger: 'blur' }]">
              <el-select v-model="form.districtCode" clearable filterable placeholder="请选择" style="width: 100%" :disabled="false">
                <el-option v-for="item in districtList" :key="item.id" :label="item.name" :value="item.districtCode" />
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="单位名称" prop="cpunitCode" :rules="[{ required: true, message: '请选择单位名称', trigger: 'blur' }]">
              <el-select
                v-model="form.cpunitCode"
                clearable
                filterable
                placeholder="请选择"
                style="width: 100%"
                @change="setRegion(form.cpunitCode, 'reset')"
              >
                 <el-option
                    v-for="item in scenicList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code"
                  ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      <el-row>
        <el-col :span="11">
          <el-form-item label="经纬度" prop="jwD"  :rules="[{ required: form.protocol == 'rtsp'? true : false, message: '请选择经纬度', trigger: 'blur' }]">
            <el-input
              v-model="form.jwD"
              v-bind:disabled="!IsEdit"
              placeholder="请选择经纬度"
            ></el-input>
          </el-form-item>
        </el-col>
        <ZjLngLatSelect
            :point_lng="form.longitude"
            :point_lat="form.latitude"
            style="margin-left: 0.5rem"
            @onGotLngLat="onGotLngLat"
          ></ZjLngLatSelect>
      </el-row>
        <el-row :gutter="14">
          <el-col :span="24">
            <el-form-item label="流地址" prop="currentAddress" v-if = "form.protocol == 'rtsp'"  :rules="[{ required: true, message: '流地址不能为空', trigger: 'blur' }]">
              <el-input v-model="form.currentAddress" placeholder="" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="14">
          <el-col :span="12">
            <el-form-item label="厂家" prop="manufacturer"  :rules="[{ required: true, message: '请选择厂家', trigger: 'blur' }]">
              <el-select v-model="form.manufacturer" clearable filterable placeholder="请选择" style="width: 100%">
                <el-option v-for="item in dict2.type['video-factory']" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="IP" prop="ip">
              <el-input v-model="form.ip" placeholder="" />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="14">
          <el-col :span="12">
            <el-form-item label="设备类型" prop="deviceType" :rules="[{ required: true, message: '请选择设备类型', trigger: 'blur' }]">
              <el-select v-model="form.deviceType" clearable filterable placeholder="请选择" style="width: 100%">
                <el-option v-for="item in dict2.type['video-device-type']" :key="item.value" :label="item.label" :value="item.value"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
         </el-row>

         <el-row :gutter="14">
            <el-col :span="12">
              <el-form-item label="apiKey" prop="apiKey">
                <el-input v-model="form.apiKey" placeholder="apiKey"/>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="apiSecret" prop="apiSecret">
                  <el-input v-model="form.apiSecret" placeholder="apiSecret"/>
              </el-form-item>
            </el-col>
        </el-row>
        <el-row :gutter="14">
            <el-col :span="12">
              <el-form-item label="排序" prop="sort">
                 <el-input-number v-model="form.sort" :min="0" :step="1" :step-strictly="true" clear controls-position="right" placeholder="请输入字段长度" style="width:100%;"/>
              </el-form-item>
            </el-col>
        </el-row>
      <el-form-item class="left">
        <el-button @click="onBack()">返回</el-button>
        <el-button
          type="primary"
          @click="saveForm()"
          :disabled="!IsEdit"
          v-if="type != 'look'"
          >保存</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { addEquipment, getEquipmentById, updateEquipment } from "@/api/src/equipment";
import { videoGetInfo, RTSPVideoUpdate, RTSPVideoSave, GbVideoSave, GbVideoUpdate } from "@/api/src/videoApiGb";
import { getEntityBaseAllInfo, getProvince, getCity, getDistrict } from "@/api/src/bigData";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  name: "MonitorEquipmentInfoNew",
  controller: "UI",
  action: "MonitorEquipmentInfoNew",
  components: {
    Treeselect
  },
  dicts2:['video-protocol','video-factory','video-device-type'],
  data() {
    return {
      provinceCode:null,
      form: {
        deviceId: null,
        name: '',
        protocol: 'rtsp',
        provinceCode: null,
        cityCode: '',
        districtCode: '',
        cpunitCode:'',
        cpunitName:'',
        currentAddress: null,
        deviceId:"",
        longitude: '',
        latitude: '',
        currentAddress:'',
        manufacturer: '',
        ip: '',
        deciveType: '',
        channelId:null,
        sourceStatus:0,
        addWay:1,
        apiKey: null,
        apiSecret: null,
      },
      rules: {},
      // 是否可编辑
      IsEdit: true,
      // 区域数据
      regionData: [],
      // 单位列表
      scenicList: [],
      provinceList:[],
      cityList: [],
      districtList: [],
      type:'add'
    };
  },
  created: function() {
    this.form.provinceCode = this.config.area.provinceCode
    this.provinceCode = this.config.area.provinceCode
    this.getUnits('scene').then(res =>{
      this.scenicList = res
    })
    this.getProvince();
    if(this.$route.query.areaTree){
      this.regionData = this.$route.query.areaTree
    }
    if(this.$route.query.type){
      this.type = this.$route.query.type
      if(this.type == 'look'){
        this.IsEdit = false
      }
    }
    if(this.$route.query.rowData){
      this.rowData = JSON.parse(this.$route.query.rowData)
      this.search(this.rowData);
    }else{
      this.getCity(this.provinceCode);
    }
  },
  methods: {
    // 获取省
    getProvince() {
      getProvince({}).then((res) => {
        this.provinceList = res.data;
      })
    },
    // 获取市
    getCity(provinceCode, set) {
      if (set) {
        this.formData.cityCode = "";
        this.formData.districtCode = "";
        this.formData.cpunitCode = "";
      }
      getCity({ provinceCode }).then((res) => {
        this.cityList = res.data;
      })
    },
    // 获取区县
    getDistrict(cityCode, set) {
      if (set) {
        this.formData.districtCode = "";
        this.districtList = [];
        this.formData.cpunitCode = "";
      }
      if (cityCode == "") {
        return;
      }
      getDistrict({ cityCode }).then((res) => {
        this.districtList = res.data;
      })
    },
    // 所属单位
    async getUnits(typeOneCode) {
      let options =[]
      let res = await getEntityBaseAllInfo({
          entityTypeCode: "subject",
          type:typeOneCode,
          typeOneCode,
          page: 1,
          size: 999,
        })
      if (res.code === 0 && res.data) {
        options = res.data
      }
      return options
    },
    // 获取行政区
    setRegion(code, set) {
      if (set) {
        this.formData.provinceCode = "";
        this.formData.cityCode = ''
        this.formData.districtCode = ''
      }
      this.scenicList.some(item => {
        if (item.code === code) {
          this.formData.provinceCode = item.provinceCode
          this.formData.cityCode = item.cityCode
          this.formData.districtCode = item.districtCode
          this.formData.cpunitName = item.name
          this.formData.entityCode = item.code
          this.formData.entityName = item.name
          this.formData.latitude = item.bdLatitude
          this.formData.longitude = item.bdLongitude
          this.getCity(item.provinceCode)
          this.getDistrict(item.cityCode)
        }
      });
    },
    // 选择经纬度
    onGotLngLat(obj) {
      this.form.longitude = obj.lng || 0;
      this.form.latitude = obj.lat || 0;
      this.form.jwD = obj.lng + ',' + obj.lat;
    },
    // 查询数据
    search({id,channelId,protocol}) {
      if(protocol == 'gb28181'){
        var param = {
          channelId,
          protocol
        }
      }else{
        var param = {
          id,
          protocol
        }
      }
      console.log(param,'000000')
      videoGetInfo(param).then(res => {
         if(res.data.type == 'rtsp'){
              res.data.protocol == 'rtsp'
            }
            res.data.deviceType = String(res.data.deviceType)
            if(res.data.entityCode){
              res.data.cpunitCode = res.data.entityCode
            }
            this.form = res.data
            this.getCity(res.data.provinceCode)
            this.getDistrict(res.data.cityCode)
      });
    },
    //返回按钮
    onBack() {
      // this.$router.go(-1); //返回上一层
      this.$router.push({
        path: "/plugin/equipment/UI/MonitorEquipmentViewNew",
        // query: { areaTree: this.regionData, typeList: this.equipmentTypeList, categoryCode: this.code, type: "add"},
      });
    },
    //保存按钮
    saveForm() {
      this.$refs["form"].validate(async(valid) => {
        if (valid) {
          let parameter = Object.assign({}, this.form)
          let res = ''
          if(parameter.protocol == 'rtsp'){
            if(parameter.id){
              res = await RTSPVideoUpdate(parameter)
            }else{
              res = await RTSPVideoSave(parameter)
            }
          }else if(parameter.protocol == 'gb28181' && !parameter.id){
            res = await GbVideoSave(parameter)
          }else{
            res = await GbVideoUpdate(parameter)
          }
          this.loading = false
          if (res.code === 0) {
            this.$message({type: "success", message: "操作成功"});
            this.onBack()
          }
        }
      })
    }
  },
};
</script>
<style scoped>
::v-deep .vue-treeselect__control{
  height: 4rem;
}
::v-deep .vue-treeselect__placeholder, 
::v-deep .vue-treeselect__single-value{
  line-height: unset;
}
::v-deep .vue-treeselect__control,
::v-deep .vue-treeselect--open-below,
::v-deep .vue-treeselect__menu{
  border-radius: 0;
}
</style>